<script>
import { VueAgile } from 'vue-agile'

export default {
  name: 'ExtendedAgile',
  extends: VueAgile,
  computed: {
    canGoToNext () {
      return (this.settings.infinite || this.currentSlide < this.countSlides - this.settings.slidesToShow)
    }
  }
}
</script>
